import React from 'react';

const Icon = ({ width = '30', height = '31', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 30 31" fill="none" {...other}>
            <g clipPath="url(#a)">
                <path
                    d="M17.854 13.12 29.022 0h-2.646l-9.698 11.392L8.933 0H0l11.712 17.226L0 30.984h2.647l10.24-12.03 8.18 12.03H30L17.853 13.12h.001Zm-3.625 4.258-1.187-1.715L3.6 2.013h4.065l7.62 11.016 1.187 1.715 9.905 14.318h-4.065l-8.083-11.684Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0 0h30v31H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
